import { OrderSummaryRow } from '.'
import { convertTitleCase } from '../../../utils/common'

const OrderSummary = ({ items = [], testWindow, first = false }) => {
  if (items.length) {
    return (
      <>
        <h5 style={!first ? { marginTop: '1em' } : {}}>{convertTitleCase(testWindow)}</h5>
        {items.map(item => (
          <OrderSummaryRow key={item.ancillaryCd} item={item} />
        ))}
      </>
    )
  }
  return null
}

OrderSummary.displayName = 'OrderSummary'

export default OrderSummary
